/* eslint-disable max-statements */
import React, { useState, useEffect, useRef } from "react";
import SFLandingBanner from "../sf-landing-page-banner";
import HighlightsStrip from "../sf-landing-page-highlights-strip";
import LoanBenefits from "../sf-landing-page-loan-benefits";
import LoanApplicationSteps from "../sf-landing-page-application-steps";
import TypesOfLoan from "../sf-landing-page-types-of-loan";
import LendingPartners from "../sf-landing-page-lending-partners";
import Faq from "../sf-landing-page-faq";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { NUMBER } from "../../../constants/app-constants";
import SFLoginController from "../sf-landing-page-login";
import isObjectEmpty from "../../../utils/helpers/isObjectEmpty";
// import { DEFAULT_SF_LANDING_SOURCE } from "../../../constants/sf-landing-constants";
import SFLandingPageBreadcrumb from "../sf-landing-page-breadcrumb";
import SFLandingPageMetaTags from "../../shared/sf-landing-page-meta-tags";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { lacLoans24WebsiteUrl } from "../../../constants/url-constants";

const slug = "seller-finance";

const SFLandingPageComponent = ({
    cms = {},
    faqList = [],
    cmsImageGallery = {},
    jsonContent = {},
    isSsr,
    isLoggedIn,
    mobile,
    // history,
    setSSRStatusConnect,
    getLandingPageDataConnect,
    sendOTPConnect,
    verifyOtpConnect
}) => {
    const [selectedLoanTypeIndex, setSelectedLoanTypeIndex] = useState(0);
    const [showLogin, setShowLogin] = useState(false);
    const [isBtnLoading, setIsBtnLoading] = useState(false);

    const typesOfLoanRef = useRef(null);

    // eslint-disable-next-line no-undef
    // const searchParams = new URLSearchParams(history?.location?.search);
    // const source = searchParams.get("source") || DEFAULT_SF_LANDING_SOURCE;

    const handleLoanTypeSelect = (loanTypeIndex) => {
        setSelectedLoanTypeIndex(loanTypeIndex);
    };

    useEffect(() => {
        setSSRStatusConnect(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (
            !isSsr &&
          (isObjectEmpty(cms) ||
            (faqList || []).length === NUMBER.ZERO ||
            isObjectEmpty(cmsImageGallery) ||
            isObjectEmpty(jsonContent))
        ) {
            const payload = { expand: "seo_content", cmsuri: slug };
            getLandingPageDataConnect(payload);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSsr]);

    // const handleCreateIntent = async () => {
    //     try {
    //         setIsBtnLoading(true);
    //         const response = await sendOTPConnect({
    //             isLoggedIn,
    //             phoneNumber: mobile,
    //             leadSource: source
    //         });
    //         const { detail } = response?.data || {};
    //         const { token = "" } = detail || {};
    //         history.push(`/seller-financing/${token}`);
    //     } catch (error) {
    //         //
    //     } finally {
    //         setIsBtnLoading(false);
    //     }
    // };

    const handleApply = async() => {
        await yieldToMain();
        setIsBtnLoading(true);
        window.location.href = `${lacLoans24WebsiteUrl()}/web-view/lac/resume?utm_source=c2b_website&utm_medium=sf_landing_page&utm_term=c2b`;
    };

    const {
        heroSection = {},
        highlightsStrip = [],
        benefitsSection = {},
        applicationSteps = {},
        loanTypes = {}
    } = jsonContent || {};

    const images = cmsImageGallery?.sf_landing || [];

    const { meta = {} } = cms || {};
    const {
        title = "",
        description = "",
        ogTitle = "",
        ogDescription = ""
    } = meta || {};

    return (
        <>
            <SFLandingPageMetaTags
                metaTitle={title}
                metaDescription={description}
                ogTitle={ogTitle}
                ogDescription={ogDescription}
            />
            <SFLandingBanner
                content={heroSection}
                images={images}
                onLoanTypeSelect={handleLoanTypeSelect}
                onApply={handleApply}
                isBtnLoading={isBtnLoading}
                scrollToRef={typesOfLoanRef}
            />
            <HighlightsStrip content={highlightsStrip} />
            <LoanBenefits content={benefitsSection} images={images} />
            <LoanApplicationSteps
                content={applicationSteps}
                images={images}
                onApply={handleApply}
                isBtnLoading={isBtnLoading}
            />
            <TypesOfLoan
                selectedLoanTypeIndex={selectedLoanTypeIndex}
                content={loanTypes}
                images={images}
                ref={typesOfLoanRef}
                onApply={handleApply}
            />
            <LendingPartners images={images} />
            <Faq />
            <SFLandingPageBreadcrumb />
            {showLogin && (
                <SFLoginController
                    onClose={() => setShowLogin(false)}
                    mobile={mobile}
                    isLoggedIn={isLoggedIn}
                    sendOtp={sendOTPConnect}
                    verifyOtp={verifyOtpConnect}
                />
            )}
        </>
    );
};

SFLandingPageComponent.propTypes = {
    cms: PropTypes.object,
    faqList: PropTypes.array,
    cmsImageGallery: PropTypes.object,
    jsonContent: PropTypes.object,
    isSsr: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    mobile: PropTypes.string,
    history: PropTypes.object,
    setSSRStatusConnect: PropTypes.func,
    getLandingPageDataConnect: PropTypes.func,
    sendOTPConnect: PropTypes.func,
    verifyOtpConnect: PropTypes.func
};

export default SFLandingPageComponent;
